export default __webpack_public_path__ + "static/media/page-title-aboutus-uz.b3af48b9.svg";